import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getXmlBillProcess } from '../../../../actions';

const BillingXmlButton = ({ dispatchGetXmlBillProcess, ticketId, loading }) => {
  if (!ticketId) return null;

  const handleDownload = (e) => {
    e.stopPropagation();
    if (!ticketId || loading) return;
    dispatchGetXmlBillProcess(ticketId);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleDownload}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !loading) {
          e.preventDefault();
          handleDownload(e);
        }
      }}
      title={loading ? 'Cargando...' : 'Descargar XML de la Facturación'}
      style={{
        cursor: loading ? 'not-allowed' : 'pointer',
        width: '48px',
        height: '48px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid #28a745',
        backgroundColor: loading ? '#e6f4ea' : 'white',
        color: '#28a745',
        fontSize: '11px',
        transition: 'all 0.2s ease-in-out',
        opacity: loading ? 0.6 : 1,
        pointerEvents: loading ? 'none' : 'auto',
      }}
    >
      {loading ? (
        <div
          className="spinner-border text-success"
          role="status"
          style={{ width: '20px', height: '20px' }}
        >
          <span className="visually-hidden">...</span>
        </div>
      ) : (
        <>
          <i
            className="fa fa-code"
            style={{
              fontSize: '16px',
              marginBottom: '3px',
              color: '#28a745',
            }}
          />
          <span style={{ color: '#28a745', fontWeight: 'bold' }}>XML</span>
        </>
      )}
    </div>
  );
};

BillingXmlButton.propTypes = {
  dispatchGetXmlBillProcess: PropTypes.func.isRequired,
  ticketId: PropTypes.string,
  loading: PropTypes.bool,
};

BillingXmlButton.defaultProps = {
  ticketId: null,
  loading: false,
};

// Mapea el estado de carga desde Redux (igual que los otros botones)
const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Billing.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetXmlBillProcess: getXmlBillProcess,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingXmlButton);
